




































































import { Vue, Prop } from 'vue-property-decorator';
import { Component } from 'vue-property-decorator';
import { Auth } from '@/kuroco_api/core/Auth';
import { LocalStorage, OpenAPI, FirebaseUtil } from '@/kuroco_api';
import { FeedStateModule, TagCategoryStateModule, TagStateModule, UserStateModule } from '@/store';

@Component<Login>({})
export default class Login extends Vue {
  // FIELDS
  input = {
    email: '',
    password: '',
    companyCd: '',
  };
  showsCompanyCdInput = false;

  // METHODS
  samlLogin(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    LocalStorage.setCompanyCd('picol');

    function createNodeWithAttributes(tagName: string, attributes: { nm: string; val: string }[] = []) {
      const node = document.createElement(tagName);
      attributes.forEach(({ nm, val }) => node.setAttribute(nm, val));
      return node;
    }

    const form = createNodeWithAttributes('form', [
      { nm: 'id', val: 'google_login_saml' },
      { nm: 'action', val: OpenAPI.getSamlUrl() },
      { nm: 'method', val: 'POST' },
    ]);
    const input = createNodeWithAttributes('input', [
      { nm: 'type', val: 'hidden' },
      { nm: 'name', val: 'api_id' },
      { nm: 'value', val: '1' },
    ]);

    form.appendChild(input);

    (document.querySelector('body') as HTMLBodyElement).appendChild(form);
    (document.querySelector('#google_login_saml') as HTMLFormElement).submit();
  }
  async submit(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    LocalStorage.setCompanyCd(this.input.companyCd);
    const memberId = await Auth.login({ requestBody: { ...this.input } }).catch((e) => {
      switch (e.status) {
        case 401:
          this.$snack.danger({ text: this.$t('loginFailed') });
          break;
        case 404:
        case 0:
          this.$snack.danger({ text: this.$t('invalidcompanyCd') });
          break;
        default:
          console.dir(e.status);
          this.$snack.danger({ text: this.$t('loginFailed') });
      }
      LocalStorage.restoreCompanyCd();
      this.showsCompanyCdInput = true;
      return Promise.reject(e);
    });

    await this.clearAllState();
    UserStateModule.initialize({ member_id: memberId as number });
    await FirebaseUtil.clear(this.input.companyCd);
    await FirebaseUtil.initialize(this.input.companyCd);
    this.$router.push({ path: '/' });
  }

  clearAllState() {
    UserStateModule.clear();
    FeedStateModule.clear();
    TagCategoryStateModule.clear();
    TagStateModule.clear();
  }

  initialize() {
    const companyCdQuery = this.$route.query?.company_cd;
    if (typeof companyCdQuery === 'string' && companyCdQuery) {
      LocalStorage.setCompanyCd(companyCdQuery);
      this.input.companyCd = companyCdQuery as string;
      this.showsCompanyCdInput = false;
      return;
    }

    const companyCdOnStorage = LocalStorage.getCompanyCd();
    if (companyCdOnStorage) {
      this.input.companyCd = companyCdOnStorage;
      this.showsCompanyCdInput = true;
      return;
    }

    this.input.companyCd = 'picol';
    this.showsCompanyCdInput = true;
  }

  mounted() {
    this.initialize();
  }
}
